import * as CONST from "../helpers/Constants";
import * as UTIL from "../helpers/Utility";
import * as Helpers from "../helpers/index";

function Reducer(state, action) {
  switch (action.type) {
    case "set_loading":
      return {
        ...state,
        isLoading: action.payload,
      };

    case "set_tags":
      return {
        ...state,
        tags: [],
      };

    case "set_settings_data":
      const sub_statuses = action.payload.all_statuses.map((i) => {
        return {
          name: i.name,
          id: i.id,
        };
      });
      return {
        ...state,
        settings: {
          ...action.payload,
          pcp_groups: action.payload.pcp_groups,
          lab_quality_measures: action.payload.quality_measurement_types
            .filter((i) => CONST.LAB_QMS.includes(i.name))
            .map((i) => {
              return {
                label: i.name,
                value: i.name,
                quality_measurement_type_id: i.id,
              };
            }),
          primary_code_quality_measures: action.payload.quality_measurement_types
            .filter((i) => CONST.PRIMARY_CODE_QMS.includes(i.name))
            .map((i) => {
              return {
                label: i.name,
                value: i.name,
                quality_measurement_type_id: i.id,
              };
            }),
          colon_cancer_screening_options: action.payload.quality_measurement_types
            .filter((i) => CONST.COLON_CANCER_SCREENING.includes(i.name))
            .map((i) => {
              return {
                label: i.name,
                quality_measurement_type_id: i.id,
              };
            }),

          kidney_function_test_options: action.payload.quality_measurement_types
            .filter((i) => CONST.KIDNEY_FUNCTION_TEST.includes(i.name))
            .map((i) => {
              return {
                label: i.name,
                quality_measurement_type_id: i.id,
              };
            }),
          patient_dashboard_enabled: action.payload.patient_dashboard_enabled,
          health_conditions: action.payload.health_conditions,
          quality_measurement_types: action.payload.quality_measurement_types,
          support_group_ids: action.payload.support_groups
            .filter((i) => i.id !== action.payload.me.support_groups[0].id)
            .map((i) => i.id),
          me: {
            ...action.payload.me,
            support_group: action.payload.me.support_groups[0].name,
            support_group_id: action.payload.me.support_groups[0].id,
          },
          pcps_by_practice: action.payload.pcp_groups.map((i) => {
            return {
              ...i,
              pcp_practices: i.pcp_practices.map((practice) => {
                return {
                  id: practice.id,
                  address: practice.address,
                  phone_number: practice.phone_number,
                  name: practice.name,
                  pcp_group_id: practice.pcp_group_id,
                  pcps: action.payload.pcps.filter((pcp) => pcp.pcp_practice_ids.includes(practice.id)),
                };
              }),
            };
          }),

          all_sub_statuses: sub_statuses,
          cpr_status_options: CONST.CPR_SUB_STATUS_OPTIONS.map((i) => {
            return {
              ...i,
              id: sub_statuses.filter((s) => s.name === i.value)[0].id,
            };
          }),
          appointment_status_options: CONST.APPOINTENT_SUB_STATUS_OPTIONS.map((i) => {
            return {
              ...i,
              id: sub_statuses.filter((s) => s.name === i.value)[0].id,
            };
          }),
          closed_sub_statuses: CONST.CLOSED_SUB_STATUSES.map((i) => {
            return { ...i, id: sub_statuses.filter((s) => s.name == i.value)[0].id };
          }),

          visit_types: action.payload.visit_types,
          appointment_sources: action.payload.appointment_sources.map((i) => {
            return {
              value: i,
              label: i.replaceAll("_", " "),
            };
          }),
          internal_communication_statuses: action.payload.internal_communication_statuses
            .map((i) => {
              return {
                value: i,
                label:
                  i == "pcp"
                    ? "PCP Issue"
                    : i == "billing_claims"
                    ? "Billing/Claim Issue"
                    : i == "wellportal"
                    ? "YwP Issue"
                    : i == "performance_tracking"
                    ? "Patient Issue"
                    : i == "health_plan"
                    ? "Health Plan Issue"
                    : "Other",
              };
            })
            .filter((v, i, a) => a.findIndex((t) => t.label === v.label) === i),
          general_patient_request_statuses: action.payload.general_patient_request_statuses.map(
            (i) => {
              return {
                value: i,
                label: i.replaceAll("_", " "),
              };
            }
          ),

          support_agents: action.payload.support_agents,
          support_groups: action.payload.support_groups,
        },
      };
    case "set_task_counts":
      return {
        ...state,
        counts: {
          ...action.payload,
        },
      };
    case "set_current_tasks":
      const tasks = action.payload.tasks.map((i) => {
        let task = {
          alert: "",
          label: "",
          waitingLabel: i.waiting_label,
          agentNote: i.agent_note,
          ...i,
        };
        if (i.task_type == "appointment_request") {
          task = {
            label: UTIL.AppointmentLabelMapper(i.appointment_request_status),
            alert: UTIL.AppointmentAlertMapper(i),
            ...i,
          };
          return task;
        }
        if (i.task_type == "cpr_response") {
          task = {
            label: UTIL.CprListLabelMapper(i.status, i.cpr),
            alert: UTIL.AppointmentAlertMapper(i),

            ...i,
          };
          return task;
        }

        if (i.task_type == "order_request") {
          task = {
            label: "Care Plan Requirement (CPR) - Order Request",
            ...i,
          };

          return task;
        }

        if (i.task_type == "quality_measure_status_check") {
          task = {
            label: "Quality Measure Status Check",
            ...i,
          };
          return task;
        } else {
          task.label = i.task_type.replaceAll("_", " ");
        }
        return {
          ...task,
        };
      });

      return {
        ...state,
        totalPages: action.payload.total_pages_count,
        totalTasks: action.payload.tasks_count,
        tagsSearched: action.payload.tasks_searched,
        tasks: tasks,
        isViewLoading: false,
        isLoading: false,
      };
    case "set_view_loading":
      return {
        ...state,
        isViewLoading: action.payload,
      };
    case "set_active_view":
      return {
        ...state,
        isViewLoading: true,
        searching: false,
        currentPage: 1,
        filter: { value: "", label: "" },
        activeView: action.payload,
      };
    case "set_current_sort_tags":
      return {
        ...state,
        activeView: "",
        tags: action.payload,
      };
    case "set_current_filter":
      return {
        ...state,
        searching: false,
        activeView: "",
        filter: { ...action.payload },
      };
    case "set_current_page":
      return {
        ...state,
        currentPage: action.payload,
      };
    case "set_searching_tasks":
      return {
        ...state,
        searching: action.payload,
        currentPage: state.currentPage,
        tags: [],
        query: {
          string: null,
          results: null,
          totalPages: null,
          totalTasks: null,
          tagsSearched: [],
          currentPage: null,
        },
      };
    case "set_tasks_query":
      return {
        ...state,
        tags: action.payload.tags,
        searching: true,
        query: {
          string: action.payload.string,
          totalPages: action.payload.totalPages,
          totalTasks: action.payload.totalTasks,
          tagsSearched: action.payload.tagsSearched,
          currentPage: action.payload.currentPage,
          results: action.payload.tasks.map((i) => {
            let task = {
              label: "",
              alert: "",
              ...i,
            };
            i.task_type == "appointment_request"
              ? (task = {
                  label: UTIL.AppointmentLabelMapper(i.appointment_request_status),
                  alert: UTIL.AppointmentAlertMapper(i),
                  ...i,
                })
              : i.task_type == "cpr_response"
              ? (task = {
                  label: UTIL.CprListLabelMapper(i.status, i.cpr),
                  alert: UTIL.AppointmentAlertMapper(i),
                  ...i,
                })
              : i.task_type
              ? (task.label = i.task_type.replaceAll("_", " "))
              : null;

            return {
              ...task,
            };
          }),
        },
      };
    case "set_error":
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case "set_task_selected":
      return {
        ...state,
        isTaskSelected: action.payload,
      };
    case "set_current_task":
      function getPrimaryQms() {
        let qmArr =
          action.payload.cpr.procedure_type == "Lab/Diagnostic Only" ||
          action.payload.cpr.procedure_type == "Lab Draw"
            ? state.settings.lab_quality_measures
            : state.settings.primary_code_quality_measures;
        let qmsNeeded = qmArr.map((i) => {
          if (action.payload.cpr.quality_measurements.find((q) => q.name == i.label)) {
            let measure = action.payload.cpr.quality_measurements.filter(
              (q) => q.name == i.label
            )[0];
            return {
              ...measure,
              document_url: measure.document_url,
              document_name: measure.document_name,
              value: measure.value,
              label: i.label,
              id: measure.id,
              quality_measurement_type_id: i.quality_measurement_type_id,
            };
          } else {
            return {
              value: "",
              label: i.label,
              id: null,
              quality_measurement_type_id: i.quality_measurement_type_id,
            };
          }
        });

        let orderedQMs = Helpers.sortArrayOfHashesByOrderedArray(qmsNeeded, 'label', CONST.PRIMARY_CODE_QMS);
        return orderedQMs;
      }

      if (action.payload.task_type == "appointment_request") {
        return {
          ...state,
          isLoading: false,
          isTaskSelected: true,
          showAllTasks: false,
          patient: action.payload.patient,
          currentTask: {
            ...action.payload,
            visitType: action.payload.procedure_type,
            cprOptions: state.settings.appointment_status_options,
            label: UTIL.AppointmentLabelMapper(action.payload.appointment_request_status),
            alert: UTIL.AppointmentAlertMapper(action.payload),
            link: action.payload.patient_page_url,
            task_messages: action.payload.task_messages,
            cpr: {
              ...action.payload.cpr,
              quality_measures_needed: action.payload.cpr.primary_code
                ? getPrimaryQms()
                : action.payload.cpr.quality_measurement_types
                ? action.payload.cpr.quality_measurement_types.map((i) => {
                    let qms = action.payload.cpr.quality_measurements
                      ? action.payload.cpr.quality_measurements
                      : [];
                    const qualityMeasure = () => {
                      if (action.payload.cpr.quality_measurements.find((q) => q.name == i.label)) {
                        let measure = qms.filter((q) => q.name == i.label)[0];
                        return {
                          value: measure.value,
                          id: measure.id,
                        };
                      } else {
                        return {
                          value: "",
                          id: null,
                        };
                      }
                    };

                    let qm = qualityMeasure();
                    return {
                      label: i.label,
                      quality_measurement_type_id: i.quality_measurement_type_id,
                      ...qm,
                    };
                  })
                : [],
              sub_status_list_id:
                action.payload.cpr.sub_status &&
                UTIL.getSubStatusListId(
                  action.payload.cpr.sub_status,
                  state.settings.all_sub_statuses
                ),
              procedure_type_id:
                action.payload.cpr.procedure_type &&
                UTIL.getVisitTypeId(action.payload.cpr.procedure_type, state.settings.visit_types),

              attending_provider: action.payload.cpr.attending_provider
                ? action.payload.cpr.attending_provider
                : "",
              servicing_provider: action.payload.cpr.servicing_provider
                ? action.payload.cpr.servicing_provider
                : "",
            },
          },
        };
      } else {
        if (["cpr_response","quality_measure_status_check"].includes(action.payload.task_type) == true) {
          const status = action.payload.status;
          const cpr = action.payload.cpr;
          const label =
            action.payload.task_type == "cpr_response"
              ? UTIL.CprLabelMapper(status, cpr)['label']
              : "Quality Measure Status Check";
          return {
            ...state,
            isLoading: false,
            isTaskSelected: true,
            showAllTasks: false,
            patient: action.payload.patient,
            currentTask: {
              ...action.payload,
              visitType: cpr.procedure_type,
              cprOptions: state.settings.cpr_status_options,
              task_messages: action.payload.task_messages,
              cpr: {
                ...action.payload.cpr,
                quality_measures_needed:
                  action.payload.cpr.primary_code || action.payload.cpr.procedure_type == "Lab Draw"
                    ? getPrimaryQms()
                    : action.payload.cpr.quality_measurement_types
                    ? action.payload.cpr.quality_measurement_types.map((i) => {
                        let qms = action.payload.cpr.quality_measurements
                          ? action.payload.cpr.quality_measurements
                          : [];
                        const qualityMeasure = () => {
                          if (
                            action.payload.cpr.quality_measurements.find((q) => q.name == i.label)
                          ) {
                            let measure = qms.filter((q) => q.name == i.label)[0];
                            return {
                              value: measure.value,
                              id: measure.id,
                            };
                          } else {
                            return {
                              value: "",
                              id: null,
                            };
                          }
                        };

                        let qm = qualityMeasure();
                        return {
                          label: i.label,
                          quality_measurement_type_id: i.quality_measurement_type_id,
                          ...qm,
                        };
                      })
                    : [],
                sub_status_list_id:
                  action.payload.cpr.sub_status &&
                  UTIL.getSubStatusListId(
                    action.payload.cpr.sub_status,
                    state.settings.all_sub_statuses
                  ),
              },
              label: label,
              link: action.payload.patient_page_url,
            },
          };
        }
      }
      return {
        ...state,
        isLoading: false,
        isTaskSelected: true,
        showAllTasks: false,
        patient: action.payload.patient,
        currentTask: {
          ...action.payload,
          task_messages: action.payload.task_messages,
          label:
            action.payload.task_type == "internal_communication"
              ? "Internal Communication Request"
              : action.payload.task_type == "general_patient_request"
              ? `General Patient Request - ${ action?.payload?.general_patient_request_status?.replace('_', ' ') }`
              : action.payload.task_type == "rx_request"
              ? "Rx Request"
              : action.payload.task_type == "abandoned_calls"
              ? "Abandoned Call"
              : action.payload.task_type == "voicemail_calls"
              ? "Voicemail Call"
              : action.payload.task_type == "outbound_calls"
              ? "Outbound Call"
              : action.payload.task_type == "inbound_calls"
              ? "Inbound Call"
              : action.payload.task_type.replaceAll("_", " "),
          link: action.payload.patient_page_url ? action.payload.patient_page_url : "",
        },
      };
    case "set_creating_task":
      return {
        ...state,
        isCreatingTask: action.payload,
        isTaskSelected: false,
        isLoading: false,
      };

    case "set_create_call_task":
      return {
        ...state,
        create: {
          type: action.payload.type,
          patient: action.payload.patient,
        },
        currentTask: {
          ...state.currentTask,
          patient: action.payload.patient,
        },
        patient: action.payload.patient,
      };
    case "set_create_task":
      return {
        ...state,
        create: {
          type: action.payload.type,
          patient: action.payload.patient,
        },
      };

    case "set_patient":
      return {
        ...state,
        patient: action.payload,
      };
    default:
      return state;
  }
}

export default Reducer;
